import React from "react";
import { Helmet } from "react-helmet-async";
import MarketingLayout from "../marketing/components/MarketingLayout";
import Hero from "../marketing/sections/Hero";
import Plateforme from "../marketing/sections/Plateforme";
import Qualification from "../marketing/sections/Qualification";
import Staffing from "../marketing/sections/Staffing";
import Modules from "../marketing/sections/Modules";
import Cas from "../marketing/sections/Cas";
import Trusted from "../marketing/sections/Trusted";
import PricingTabs from "../marketing/sections/PricingTabs";
import Faq from "../marketing/sections/Faq";

const Home = () => (
  <MarketingLayout>
    <Helmet>
      <title>ASAP Hub - L'IA opérationnelle pour ESN & cabinets de conseil</title>
      <meta name="description" content="ASAP Hub centralise CV, compétences, staffing, profils et partenaires pour aider les ESN et cabinets de conseil à répondre plus vite aux opportunités." />
      <link rel="canonical" href="https://www.asap-hub.ai/" />
      <meta property="og:title" content="ASAP Hub - Plateforme IA pour ESN" />
      <meta property="og:description" content="Pilotez votre activité de A à Z, boostez votre croissance, gérez vos talents et projets grâce à l'Intelligence Artificielle." />
      <meta property="og:url" content="https://www.asap-hub.ai/" />
      <meta property="og:type" content="website" />
    </Helmet>
    <Hero />
    <Plateforme />
    <Qualification />
    <Staffing />
    <Modules />
    <Cas />
    <Trusted />
    <PricingTabs />
    <Faq />
  </MarketingLayout>
);

export default Home;
